import { render, staticRenderFns } from "./ResolveModal.vue?vue&type=template&id=58c2e4de"
import script from "./ResolveModal.vue?vue&type=script&lang=js"
export * from "./ResolveModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports